import ReactPlayer from "react-player";
import React, { useState, useEffect } from "react";
import ModalComponent from "../atoms/modalComponent";
import { constants } from "../../data/data";
import nftvideo from "../../assets/video/coin.mp4";
import "./NftBuy.css";
import { Contract, ethers } from "ethers";
import { useWeb3React } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import { contractABI } from "../../coiABI";
import Spinner from "react-bootstrap/Spinner";
import { Communitypartner } from "./communitypartner";
import Benifit from "./Benifit";
import { Newsletter } from "./newsletter";
import { Burgermenu } from "./burgermenu";

const NftBuy = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [nftQuentity, setNftQuentity] = useState(0);
  const [count, setCount] = useState(0);

  const [openMenu, setOpenMenu] = useState(false);

  const burgerIconClick = () => {
    if (openMenu) {
      setOpenMenu(false);
    } else {
      setOpenMenu(true);
    }
  };

  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const countDownDate = new Date("2023-02-06").getTime();
    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTime({ days, hours, minutes, seconds });

      if (distance < 0) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const [Loader, setLoader] = useState(false);

  const [totalNft, setTotalNft] = useState(0);
  const [totalmintNft, setTotalMintNft] = useState(0);
  const { active, activate, deactivate, chainId, account } = useWeb3React();

  const Injected = new InjectedConnector({
    supportedChainIds: [1, 3, 4, 5, 42, 80001, 127],
  });
  const contractAddress = "0x942b353494b018Ea4A09aBc0dc18E93025fe776c";
  const provider = window.ethereum
    ? new ethers.providers.Web3Provider(window.ethereum)
    : new ethers.providers.JsonRpcProvider(
        "https:goerli.infura.io/v3/855bc57cbb774a5bb53ea687257e1c29"
      );
  const signer = provider.getSigner();
  const contract = new Contract(contractAddress, contractABI, signer);

  const connectWalletHandler = async () => {
    setLoader(true);

    if (window.ethereum) {
      if (active) {
        setLoader(false);
      } else {
        await activate(Injected);
      }
    } else {
      setLoader(false);
      alert("Please Install Metamask");
    }
  };

  useEffect(() => {
    if (window.ethereum) {
      deactivate();
    }
  }, []);

  useEffect(() => {
    if (window.ethereum) {
      if (active) {
        setWalletAddress(account);
        setLoader(false);
      }
    }
  }, [connectWalletHandler, Loader]);

  const mintNftHandler = async () => {
    if (window.ethereum) {
      setLoader(true);
      if (count > 2 || count < 0) {
        setLoader(false);
      } else {
        const result = await contract.mint(walletAddress, count, "0x00");
        console.log(result);
        if (result) {
          setLoader(false);
        }
      }
    } else {
      alert("Please Install Metamask");
    }
  };

  const changeNetworkHandler = async () => {
    console.log("change network");
  };

  const increment = () => {
    setCount((prevState) => {
      if (prevState > 1) {
        return 2;
      }
      return prevState + 1;
    });
  };

  const decrement = () => {
    setCount((prevState) => {
      if (prevState > 0) {
        return prevState - 1;
      }
      return 0;
    });
  };

  const balanceNft = async () => {
    if (window.ethereum) {
      return await contract.balanceOf(walletAddress, 1);
    } else {
      return 0;
    }
  };

  const getTotalNft = async () => {
    if (window.ethereum) {
      return await contract.totalNftLimit();
    } else {
      return 0;
    }
  };

  const getTotalMintNft = async () => {
    if (window.ethereum) {
      return await contract.totalCountOfNft();
    } else {
      return 0;
    }
  };

  useEffect(async () => {
    if (window.ethereum) {
      setTotalNft(Number(await getTotalNft()));
      setTotalMintNft(Number(await getTotalMintNft()));
      if (active) {
        setNftQuentity(Number(await balanceNft()));
      }
    }
  }, []);

  return (
    <>
      <div className="header-container">
        <div className="container">
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-xs-2 logo-wrapper">
              <a className="logo" href="#page-top">
                <img src="img/h_logo.svg" alt="colours of india logo" />
              </a>
            </div>
            {/* <div className='col-xs-6 navigation-wrapper'>
            <div className='header-search-bar-wrapper'>
             
            </div>
          </div> */}

            <div
              className="col-xs-10 submit-work-wrapper "
              style={{ display: "flex" }}
            >
              {window.innerWidth > 768 ? (
                <>
                  <a
                    href={
                      props.data
                        ? props.data.discord
                        : "https://coloursofindianft.com/#artgallery"
                    }
                    className="header-submit-work mx-4"
                    style={{
                      color: "#000",
                    }}
                    target="blank"
                  >
                    Art Gallery
                  </a>
                  <a
                    href={"https://coidao.upstreamapp.com/"}
                    className="header-submit-work mx-4"
                    style={{
                      color: "#000",
                    }}
                    target="blank"
                  >
                    DAO
                  </a>
                  <a
                    href={
                      props.data
                        ? props.data.discord
                        : "https://coloursofindianft.com/#irlevents"
                    }
                    className="header-submit-work mx-4"
                    style={{
                      color: "#000",
                    }}
                    target="blank"
                  >
                    IRL Events
                  </a>
                  <a
                    href={
                      props.data
                        ? props.data.discord
                        : "https://coloursofindianft.com/#benifits"
                    }
                    className="header-submit-work mx-4"
                    style={{
                      color: "#000",
                    }}
                    target="blank"
                  >
                    Benifits
                  </a>
                  <a
                    href={
                      props.data
                        ? props.data.discord
                        : "https://coloursofindianft.com/#partners"
                    }
                    className="header-submit-work mx-4"
                    style={{
                      color: "#000",
                    }}
                    target="blank"
                  >
                    Partners
                  </a>
                  <a
                    href={
                      props.data
                        ? props.data.discord
                        : "https://mint.coloursofindianft.com/"
                    }
                    className="btn btn-custom btn-lg header-submit-work mx-4"
                    style={{
                      backgroundColor: "#4daeb4",
                      borderColor: "#4daeb4",
                    }}
                    target="blank"
                  >
                    Mint COI NFT
                  </a>
                </>
              ) : (
                <Burgermenu
                  burgerIconClick={burgerIconClick}
                  iconState={openMenu}
                />
              )}
            </div>
          </div>
          <div className="row" style={{ alignItems: "center" }}>
            <div
              className={
                openMenu
                  ? "d-block col-xs-12 col-lg-8 navigation-wrapper-menu"
                  : "d-none"
              }
            >
              <div
                className={
                  "d-block d-lg-flex col-xs-12 col-lg header-redirections"
                }
              >
                <a
                  className="col-xs-12 btn  btn-lg col-lg"
                  href="https://coloursofindianft.com/#artgallery"
                >
                  <span>Art Gallery</span>
                </a>
                <a
                  className="col-xs-12 btn  btn-lg col-lg"
                  href="https://coidao.upstreamapp.com/"
                >
                  <span>DAO</span>
                </a>
                <a
                  className="col-xs-12 btn  btn-lg col-lg"
                  href="https://coloursofindianft.com/#irlevents"
                >
                  <span>IRL Events</span>
                </a>

                <a
                  className="col-xs-12 btn  btn-lg col-lg"
                  href="https://coloursofindianft.com/#benifits"
                >
                  <span>Benifits</span>
                </a>
                <a
                  className="col-xs-12 btn  btn-lg col-lg"
                  href="https://coloursofindianft.com/#partners"
                >
                  <span>Partners</span>
                </a>
                <a
                  href={
                    props.data
                      ? props.data.discord
                      : "https://mint.coloursofindianft.com/"
                  }
                  className="btn  btn-lg col-xs-12 col-lg header-submit-work "
                  style={{
                    backgroundColor: "#4daeb4",
                    borderColor: "#4daeb4",
                  }}
                  target="blank"
                >
                  Mint COI NFT
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="welcome-container">
        <ModalComponent
          show={modalShow}
          onHide={() => setModalShow(false)}
          heading={"About COI"}
          content={constants.KnowMore.aboutCoi}
        />

        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 offset-sm-0 col-md-5">
              <div
                className="card"
                id="orangeButton"
                style={{ borderRadius: "0px " }}
              >
                <video autoPlay loop muted>
                  <source src={nftvideo} type="video/mp4" className="border" />
                </video>
              </div>
              <div className="row ">
                <div className="col">
                  <p className="welcome-subheading">Total Mint</p>
                </div>
                <div className="col">
                  <p className="text-end welcome-subheading">
                    {totalmintNft}/{totalNft}
                  </p>
                </div>
              </div>

              <div className="row ">
                <div className="col">
                  <p className="h4 text-white">COI NFT Balance </p>
                </div>
                <div className="col">
                  <p className="text-end h4 text-white">{nftQuentity}</p>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-8 ">
                  {!walletAddress && (
                    <button
                      className="btn addOrangeNeon w-100"
                      onClick={connectWalletHandler}
                      style={{
                        backgroundColor: "#1212",
                        borderColor: "#F4C773",
                        color: "#F4C773",
                        height: "80px",
                        fontSize: "20px",
                        borderRadius: "2rem",
                      }}
                    >
                      {Loader ? (
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      ) : (
                        "Connect a Wallet"
                      )}
                    </button>
                  )}
                  {walletAddress && (
                    <>
                      {nftQuentity >= 2 ? (
                        <div className="row ">
                          <div className="col">
                            <p className="h4 text-white">
                              You Can't Mint NFT because you have minted 2 NFT{" "}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="mb-3">
                          <div className="row ">
                            <div className="col d-flex justify-content-center">
                              <button
                                className="btn btn-lg bg-white "
                                onClick={increment}
                              >
                                +
                              </button>
                            </div>
                            <div className="col d-flex justify-content-center text-center">
                              {/* <input type={"number"} min={0} max={2} value={totalMint} onChange={(e)=>{setTotalMint(e.target.value)}} className="btn btn-lg bg-white w-100 " /> */}
                              <p className="btn btn-lg bg-white w-100 ">
                                {count === 0 ? 0 : count}
                              </p>
                            </div>
                            <div className="col d-flex justify-content-center">
                              <button
                                className="btn btn-lg bg-white  "
                                onClick={decrement}
                              >
                                -
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {chainId === 5 ? (
                        <button
                          className="btn addOrangeNeon w-100 "
                          style={{
                            backgroundColor: "#1212",
                            borderColor: "#F4C773",
                            color: "#F4C773",
                            height: "80px",
                            fontSize: "20px",
                            borderRadius: "2rem",
                          }}
                          onClick={mintNftHandler}
                          disabled={nftQuentity >= 2 ? true : false}
                        >
                          {Loader ? (
                            <Spinner animation="border" role="status">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </Spinner>
                          ) : (
                            "Mint NFT"
                          )}
                        </button>
                      ) : (
                        <button
                          className="btn addOrangeNeon w-100 "
                          style={{
                            backgroundColor: "#1212",
                            borderColor: "#F4C773",
                            color: "#F4C773",
                            height: "80px",
                            fontSize: "20px",
                            borderRadius: "2rem",
                          }}
                          onClick={changeNetworkHandler}
                        >
                          {Loader ? (
                            <Spinner animation="border" role="status">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </Spinner>
                          ) : (
                            "Change Network"
                          )}
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12  col-md-6 offset-lg-1   ">
              <div className=" align-items-center d-flex h-100 justify-content-center py-1">
                <div className="">
                  <p className="welcome-heading text-center ">
                    COLOURS OF INDIA (COI) DAO
                  </p>
                  <p className="welcome-subheading">
                    We are on a mission to bring Indian NFT art to the world! As
                    the first DAO of its kind in the subcontinent, we aim to
                    develop a vibrant culture of diversity, openness and freedom
                    of expression. Join the movement.
                  </p>
                  <p>
                    <a
                      href={props.data ? props.data.discord : "/"}
                      className="btn btn-custom btn-lg know-more-anchor"
                      style={{
                        backgroundColor: "#4daeb4",
                        borderColor: "#4daeb4",
                      }}
                      target="blank"
                      onClick={(event) => {
                        event.preventDefault();
                        setModalShow(true);
                      }}
                    >
                      Know More
                    </a>
                  </p>
                  {/* {time.days == 0 &&
                    time.hours == 0 &&
                    time.minutes == 0 &&
                    time.seconds == 0 && ( */}
                  <br />
                  <br />
                  <br />
                  <div
                    style={{
                      border: "1px solid #8038e9",
                      borderRadius: "1rem",
                      background: "#4daeb4",
                    }}
                    className={"py-5 my-3"}
                  >
                    <p
                      className="welcome-heading text-center "
                      style={{ color: "#fff" }}
                    >
                      Presale For NFT
                    </p>
                    <div>
                      <p
                        className="welcome-heading text-center "
                        style={{ color: "#000" }}
                      >
                        <div
                          className=" d-flex justify-content-center p-3 "
                          style={{ gap: "15px" }}
                        >
                          <div className="">
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                width: "90px",
                              }}
                              className={"p-4"}
                            >
                              {time.days}
                              <br />
                              <h4>Days</h4>
                            </div>
                          </div>
                          <div className="">
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                width: "90px",
                              }}
                              className={"p-4"}
                            >
                              {time.hours}
                              <br />
                              <h4>Hours</h4>
                            </div>
                          </div>
                          <div className="">
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                width: "90px",
                              }}
                              className={"p-4"}
                            >
                              {time.minutes}
                              <br />
                              <h4>Min</h4>
                            </div>
                          </div>
                          <div className="">
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                width: "90px",
                              }}
                              className={"p-4"}
                            >
                              {time.seconds}
                              <br />
                              <h4>Sec</h4>
                            </div>
                          </div>
                        </div>

                        {/* {` ${time.days}D ${time.hours}H ${time.minutes}M ${time.seconds}S`} */}
                      </p>
                    </div>
                  </div>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Communitypartner />
      <Benifit />
      <Newsletter />
    </>
  );
};
export default NftBuy;

// {!walletAddress && (
//   <button
//     className="btn addOrangeNeon w-100"
//     onClick={connectWalletHandler}
//     style={{
//       backgroundColor: "#1212",
//       borderColor: "#F4C773",
//       color: "#F4C773",
//       height: "80px",
//       fontSize: "20px",
//       borderRadius: "2rem",
//     }}
//   >
//     {Loader ? (
//       <Spinner animation="border" role="status">
//         <span className="visually-hidden">Loading...</span>
//       </Spinner>
//     ) : (
//       "Connect a Wallet"
//     )}
//   </button>
// )}
// {walletAddress && (
//   <>
//     {nftQuentity >= 2 ? (
//       <div className="row ">
//         <div className="col">
//           <p className="h4 text-white">
//             You Can't Mint NFT because you have minted 2 NFT{" "}
//           </p>
//         </div>
//       </div>
//     ) : (
//       <div className="mb-3">
//         <div className="row ">
//           <div className="col d-flex justify-content-center">
//             <button
//               className="btn btn-lg bg-white "
//               onClick={increment}
//             >
//               +
//             </button>
//           </div>
//           <div className="col d-flex justify-content-center text-center">
//             {/* <input type={"number"} min={0} max={2} value={totalMint} onChange={(e)=>{setTotalMint(e.target.value)}} className="btn btn-lg bg-white w-100 " /> */}
//             <p className="btn btn-lg bg-white w-100 ">
//               {count === 0 ? 0 : count}
//             </p>
//           </div>
//           <div className="col d-flex justify-content-center">
//             <button
//               className="btn btn-lg bg-white  "
//               onClick={decrement}
//             >
//               -
//             </button>
//           </div>
//         </div>
//       </div>
//     )}

//     {chainId === 5 ? (
//       <button
//         className="btn addOrangeNeon w-100 "
//         style={{
//           backgroundColor: "#1212",
//           borderColor: "#F4C773",
//           color: "#F4C773",
//           height: "80px",
//           fontSize: "20px",
//           borderRadius: "2rem",
//         }}
//         onClick={mintNftHandler}
//         disabled={nftQuentity >= 2 ? true : false}
//       >
//         {Loader ? (
//           <Spinner animation="border" role="status">
//             <span className="visually-hidden">
//               Loading...
//             </span>
//           </Spinner>
//         ) : (
//           "Mint NFT"
//         )}
//       </button>
//     ) : (
//       <button
//         className="btn addOrangeNeon w-100 "
//         style={{
//           backgroundColor: "#1212",
//           borderColor: "#F4C773",
//           color: "#F4C773",
//           height: "80px",
//           fontSize: "20px",
//           borderRadius: "2rem",
//         }}
//         onClick={changeNetworkHandler}
//       >
//         {Loader ? (
//           <Spinner animation="border" role="status">
//             <span className="visually-hidden">
//               Loading...
//             </span>
//           </Spinner>
//         ) : (
//           "Change Network"
//         )}
//       </button>
//     )}
//   </>
// )}
